import { c as _c } from "react/compiler-runtime";
import { FeatureReviewPanel } from "@/lib/components/admin/FeatureReviewPanel";
import { PlaceReviewPanel } from "@/lib/components/admin/PlaceReviewPanel";
import { jsx as _jsx } from "react/jsx-runtime";
export function ReviewDetailPane(t0) {
  const $ = _c(25);
  const {
    selection,
    isApproving,
    isRejecting,
    isRepositioning,
    onApprove,
    onReject,
    onReposition,
    rejectDialogOpen,
    onOpenRejectDialog,
    onCloseRejectDialog
  } = t0;
  if (!selection) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = /*#__PURE__*/_jsx("div", {
        className: "flex h-full items-center justify-center p-8 text-sm text-gray-500",
        children: "V\xE4lj n\xE5got i listan f\xF6r att granska"
      });
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (selection.type === "place") {
    const t1 = `place-${selection.id}`;
    let t2;
    if ($[1] !== isApproving || $[2] !== isRejecting || $[3] !== isRepositioning || $[4] !== onApprove || $[5] !== onCloseRejectDialog || $[6] !== onOpenRejectDialog || $[7] !== onReject || $[8] !== onReposition || $[9] !== rejectDialogOpen || $[10] !== selection.id || $[11] !== t1) {
      t2 = /*#__PURE__*/_jsx(PlaceReviewPanel, {
        placeId: selection.id,
        isApproving: isApproving,
        isRejecting: isRejecting,
        isRepositioning: isRepositioning,
        onApprove: onApprove,
        onReject: onReject,
        onReposition: onReposition,
        rejectDialogOpen: rejectDialogOpen,
        onOpenRejectDialog: onOpenRejectDialog,
        onCloseRejectDialog: onCloseRejectDialog
      }, t1);
      $[1] = isApproving;
      $[2] = isRejecting;
      $[3] = isRepositioning;
      $[4] = onApprove;
      $[5] = onCloseRejectDialog;
      $[6] = onOpenRejectDialog;
      $[7] = onReject;
      $[8] = onReposition;
      $[9] = rejectDialogOpen;
      $[10] = selection.id;
      $[11] = t1;
      $[12] = t2;
    } else {
      t2 = $[12];
    }
    return t2;
  }
  const t1 = `feature-${selection.id}`;
  let t2;
  if ($[13] !== isApproving || $[14] !== isRejecting || $[15] !== isRepositioning || $[16] !== onApprove || $[17] !== onCloseRejectDialog || $[18] !== onOpenRejectDialog || $[19] !== onReject || $[20] !== onReposition || $[21] !== rejectDialogOpen || $[22] !== selection.id || $[23] !== t1) {
    t2 = /*#__PURE__*/_jsx(FeatureReviewPanel, {
      featureId: selection.id,
      isApproving: isApproving,
      isRejecting: isRejecting,
      isRepositioning: isRepositioning,
      onApprove: onApprove,
      onReject: onReject,
      onReposition: onReposition,
      rejectDialogOpen: rejectDialogOpen,
      onOpenRejectDialog: onOpenRejectDialog,
      onCloseRejectDialog: onCloseRejectDialog
    }, t1);
    $[13] = isApproving;
    $[14] = isRejecting;
    $[15] = isRepositioning;
    $[16] = onApprove;
    $[17] = onCloseRejectDialog;
    $[18] = onOpenRejectDialog;
    $[19] = onReject;
    $[20] = onReposition;
    $[21] = rejectDialogOpen;
    $[22] = selection.id;
    $[23] = t1;
    $[24] = t2;
  } else {
    t2 = $[24];
  }
  return t2;
}